<template>
  <div>
    <div class="group_12 flex-box">
      <div class="box_51">
        <div class="block">
          <el-carousel trigger="click" height="402px">
            <el-carousel-item v-for="item in imgUrlList" :key="item.id">
              <div class="block_2" @click="jumpDetails(item.id, 1)">
                <img :src="baseUrl + '\\' + item.img" alt="" />
                <div class="box_10">
                  <h4 class="small">{{ item.title }}</h4>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="box_1">
          <div class="box_2">
            <div class="box_3" v-if="tabList.length > 0">
              <span
                :class="active === 0 ? 'active' : ''"
                style="margin-right: 10px"
                @click="active = 0"
                >{{ tabList[0].name }}</span
              >
              <span :class="active === 1 ? 'active' : ''" @click="active = 1">{{
                tabList[1].name
              }}</span>
            </div>
            <div class="box_4" @click="jump(tabList[active])">更多 ></div>
          </div>
          <div class="infinite">
            <scroll-panel
              :type="tabList[0].solrKey"
              :index="0"
              v-if="active === 0"
            ></scroll-panel>
            <scroll-panel
              :type="tabList[1].solrKey"
              :index="1"
              v-if="active === 1"
            ></scroll-panel>
          </div>
        </div> -->
        <div class="box_1">
          <div class="more" @click="jump(tabList[parseInt(activeName)])">
            更多 >
          </div>
          <el-tabs v-model="activeName">
            <el-tab-pane
              v-for="(item, index) in tabList"
              :key="index"
              :label="item.name"
              :name="index.toString()"
            >
              <div class="infinite">
                <scroll-panel
                  :type="item.solrKey"
                  :index="index.toString()"
                ></scroll-panel></div
            ></el-tab-pane>
          </el-tabs>
        </div>

        <div class="box_1" v-for="(item, index) in queueList" :key="item.id">
          <div class="box_2">
            <div class="box_3">{{ item.name }}</div>
            <div class="box_4" @click="jump(item)">更多 ></div>
          </div>
          <div class="box_6"></div>
          <div class="infinite">
            <scroll-panel :type="item.solrKey" :index="index"></scroll-panel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexList, getPanelQueue, addPanelQueue } from "@/api/api";
import scrollPanel from "../scrollPanel.vue";
import baseurl from "@/api/baseUrl";
export default {
  components: {
    scrollPanel,
  },
  data() {
    return {
      imgUrlList: [],
      queueList: [],
      tabList: [],
      activeName: "0",
    };
  },
  mounted() {},
  created() {
    this.getIndexList();
    this.getPanelQueue();
  },
  watch: {
    isModify(newVal) {
      if (newVal) {
        this.getPanelQueue();
        this.$store.commit("setIsModify", false);
      }
    },
  },
  computed: {
    isModify() {
      return this.$store.getters.isModify;
    },
    baseUrl() {
      return baseurl;
    },
  },
  methods: {
    async getIndexList() {
      //文章列表
      const res = await getIndexList();
      res.data.forEach((item, index) => {
        this.imgUrlList.push(item);
      });
    },
    jump(item) {
      let routerUrl = this.$router.resolve({
        path: "/biology",
        query: { id: item.solrKey, name: item.name, type: item.id },
      });
      window.open(routerUrl.href);
    },
    jumpDetails(id, type) {
      let routerUrl = this.$router.resolve({
        path: "/articleDetails",
        query: { id, type },
      });
      window.open(routerUrl.href);
    },
    // 获取栏目
    getPanelQueue() {
      getPanelQueue().then((res) => {
        let data = res.data.data;
        let nameList = data.typeName.split(",");
        let idList = data.typeId.split(",");
        let keyList = data.solrKey.split(",");

        if (nameList.length === nameList.length) {
          nameList.map((item, index) => {
            let obj = {
              id: idList[index],
              name: item,
              solrKey: keyList[index],
            };
            // 永远设置医学前沿在第一块区域显示
            if (keyList[index] === "10") {
              this.tabList.push(obj);
            } else if (keyList[index] !== "1") {
              this.queueList.push(obj);
            }
          });

          // 给第一块添加最前的排序的栏目
          this.tabList.unshift(this.queueList[0]);
          this.queueList.shift();
          if (!data.id && sessionStorage.getItem("isLogin") === "1") {
            // 如果默认没有栏目则添加
            addPanelQueue({ ...data, id: null });
          }
        } else {
          this.$message.error("栏目查询出错");
          return;
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.infinite {
  height: 300px;
}
.flex-box {
  display: flex;
}

::v-deep .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.group_12 {
  box-shadow: 0px 0px 18px 0px rgb(0 0 0 / 6%);
  background-color: white;
  width: 100%;
  padding: 16px;
  position: relative;
  left: 6%;
  .box_51 {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: wrap;
    .box_1:nth-child(2) {
      margin-top: 0px;
    }
    .block {
      width: 60%;
    }
    .block_2 {
      position: relative;
      width: 100%;
      height: 402px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
      .box_10 {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 122px;
        z-index: 1;
        background: url(../../assets/img/SketchPng3cbe21f12bbc17c0d1ad6029e3f67bc36c5de3a7cee377dea86bcba35bea1ff9.png);

        h4 {
          color: #fff;
          line-height: 122px;
          margin-left: 30px;
          width: 50%; //设置宽度
          overflow: hidden; //超出隐藏
          white-space: nowrap; //设置文字不换行
          text-overflow: ellipsis; //超出显示...
        }
      }
    }

    ::v-deep .el-tabs__item.is-active {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0b70c1;
    }

    ::v-deep .el-tabs__item {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0b70c1;
    }

    ::v-deep .el-tabs__active-bar {
      width: 32px !important;
      height: 3px;
      background: #51a8ff;
      border-radius: 2px;
      margin-left: 16px;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      height: 0px;
    }

    .box_1 {
      position: relative;
      box-sizing: border-box;
      width: 30%;
      margin: 30px 0;
      .more {
        position: absolute;
        top: 10px;
        right: 0px;
        color: #0b70c1;
        cursor: pointer;
        z-index: 99;
      }
      ul {
        li {
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #000000;
          line-height: 22px;
          cursor: pointer;
          width: 100%;
          margin-top: 5px;
          display: flex;
        }
        li:hover {
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          line-height: 22px;
          color: #13509f;
        }
      }
      .box_2 {
        display: flex;
        justify-content: space-between;
        color: #0b70c1;
        margin-bottom: 6px;
        span {
          cursor: pointer;
        }
        .box_3 {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
        }
        .box_4 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          cursor: pointer;
        }
      }
      .box_6 {
        width: 32px;
        height: 3px;
        background: #51a8ff;
        border-radius: 2px;
        margin-left: 16px;
      }
    }
  }
}
</style>